import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { AssignedWorkAreaDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { getCarrierAssignments } from '../../tableConfigs/operationalEquipmentTableHelper'

interface Props {
  assignments: AssignedWorkAreaDto[]
}

export const OperationalEquipmentCarrierAssignment = ({ assignments }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  if (assignments.length === 0)
    return <Typography variant='body2'>{t('notAssigned', 'Not assigned')}</Typography>

  const distinctVisits = getCarrierAssignments(assignments)

  const carrierVisitToShow = distinctVisits.sort((a, b) => dayjs(b.ata).diff(a.ata))[0]

  return (
    <Stack
      direction='row'
      gap={theme.customSpacing.m}
      alignItems='center'
      justifyContent='space-between'
    >
      <Stack>
        <Typography variant='body2'>{carrierVisitToShow.carrierName}</Typography>

        {carrierVisitToShow.ata && (
          <Typography variant='caption'>
            {t('ata', 'ATA')}:{' '}
            {new Date(carrierVisitToShow.ata ?? '').toLocaleTimeString([], {
              timeStyle: 'short',
              hour12: false,
            })}
            , {dayjs(carrierVisitToShow.ata).format('l')}
          </Typography>
        )}
      </Stack>

      {distinctVisits.length > 1 && (
        <ColoredLabel color='secondary' label={`+${distinctVisits.length - 1}`} />
      )}
    </Stack>
  )
}
